import { render, staticRenderFns } from "./finance-repayment-dev-details.vue?vue&type=template&id=ad64de30&scoped=true&"
import script from "./finance-repayment-dev-details.vue?vue&type=script&lang=js&"
export * from "./finance-repayment-dev-details.vue?vue&type=script&lang=js&"
import style0 from "./finance-repayment-dev-details.vue?vue&type=style&index=0&id=ad64de30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad64de30",
  null
  
)

export default component.exports